module.exports = __webpack_public_path__ + "static/hero-35d371824b4d7945637b4eb159dbb3e0.jpg";